import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useAuthModalStore } from '../store/authModalStore';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: React.ReactNode;
  className?: string;
}

const ProtectedLink: React.FC<Props> = ({ to, children, className, onClick, ...rest }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const openLogin = useAuthModalStore((s) => s.openLogin);
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (onClick) onClick(e);
    if (isAuthenticated) {
      navigate(to);
    } else {
      openLogin();
    }
  };

  return (
    <a href={to} className={className} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default ProtectedLink;
